const urls = {
	sendText: "/send-text",
	winners: "/winners",
	winnersUpdate: "/winners/",
	stats: {
		watchedCount: "/stats/watched_count",
		guessAccuracy: "/stats/guess-accuracy",
		winLoss: "/stats/win-loss",
		score: "/stats/score",
	},
	results: "/results",
	predictions: "/predictions",
	watchlist: "/watchlist",
};

export default urls;
